import { zodResolver } from '@hookform/resolvers/zod'
import * as R from 'remeda'
import { z } from 'zod'

const schema = z.object({
  customerAttributes: z
    .array(
      z.object({
        id: z.string().min(1),
        checked: z.boolean(),
        name: z.string().min(1),
      }),
    )
    .refine((val) => val.some(R.prop('checked'))),
})
export type InputValues = z.infer<typeof schema>
export const resolver = zodResolver(schema)
